import axios from "axios";
import { PPD_BUDGET, PPD_BUDGET_SAVE, SET_ERROR } from "../../types";

/**
 * 
 * @param {String} companyShortName 
 * @returns 
 */
export const getPPDBudget = companyShortName => {
    return async dispatch => {
        await axios.get(`api/ppd/budget/${companyShortName}`).then(res => {
            dispatch({
                type: PPD_BUDGET,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};

export const addUpdateBudget = payload => {
    return async dispatch => {
        await axios.post('api/ppd/add-update-budget', payload).then(res => {
            dispatch({
                type: PPD_BUDGET_SAVE,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};